module.exports = __webpack_public_path__ + "static/media/Local.80f93262.svg";